import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized }  from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"
// Aliments actions

export const GET_ALIMENTS_PENDING = "GET_ALIMENTS_PENDING";
export const GET_ALIMENTS_REJECTED = "GET_ALIMENTS_REJECTED";
export const GET_ALIMENTS_FULFILLED = "GET_ALIMENTS_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_ALIMENTS_PENDING:
      return true;
    case GET_ALIMENTS_REJECTED:
    case GET_ALIMENTS_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ALIMENTS_PENDING:
    case GET_ALIMENTS_FULFILLED:
      return null;
    case GET_ALIMENTS_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_ALIMENTS_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return null;
  }
};

// ALIMENTS reducer
export default combineReducers({ loading, error, data });

export const getAlimentsSimple = (tok,id) => {
  return (dispatch) => {
    dispatch({ type: GET_ALIMENTS_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/alimentations`,{ headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_ALIMENTS_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_ALIMENTS_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
